import { useQuery } from "react-query";

import { searchService } from "services";

type UseInstallationSearchQueryProps = {
	pattern: string;
	page: number;
	options?: any;
};

const useInstallationSearchQuery = ({
	pattern,
	page,
	options,
}: UseInstallationSearchQueryProps) =>
	useQuery(
		["installationSearch", pattern, page],
		() =>
			searchService.getInstallations({
				pattern,
				page,
			}),
		{
			...options,
		},
	);

export default useInstallationSearchQuery;
